import { useCallback } from 'react';
import FilterToggleGroup, { FilterToggleRow } from '../../common/list/FilterToggleGroup';

const prjTyps = [
  { id: 0, value: '', label: '전체', color: null },
  { id: 1, value: 'N', label: '프로젝트', color: 'info' },
  { id: 2, value: 'M', label: '유지보수', color: 'success' },
];

// 중요도 필터(전체/H/M/L) - 수정안_0312_2 "포캐스팅 리스트 수정(제안2)" 시안
const prjImpts = [
  { id: 0, value: '', label: '전체', color: null },
  { id: 1, value: 'H', label: 'H', color: 'error' },
  { id: 2, value: 'M', label: 'M', color: 'warning' },
  { id: 3, value: 'L', label: 'L', color: 'success' },
];

const chanceStatus = [
  { id: 0, value: '', label: '전체', color: null },
  { id: 1, value: '1', label: '기회확인', color: 'info' },
  { id: 2, value: '2', label: '기회분석', color: 'error' },
  { id: 3, value: '3', label: '매출견적', color: 'success' },
  { id: 4, value: '4', label: '수주품의', color: 'secondary' },
];

// 중요도/단계/타입 필터 - 단일선택 ToggleButtonGroup(공통 FilterToggleGroup, 2026-10-22).
const ChanceStatusList = ({ filters, onFilters }) => {
  const handleFilterType = useCallback((value) => onFilters('searchPrjTyp', value), [onFilters]);
  const handleFilterStatus = useCallback((value) => onFilters('searchGrade', value), [onFilters]);
  const handleFilterImpt = useCallback((value) => onFilters('searchPrjImpt', value), [onFilters]);

  return (
    <FilterToggleRow>
      <FilterToggleGroup label="중요도" options={prjImpts} value={filters.searchPrjImpt} onChange={handleFilterImpt} />
      <FilterToggleGroup label="단계" options={chanceStatus} value={filters.searchGrade} onChange={handleFilterStatus} />
      <FilterToggleGroup label="타입" options={prjTyps} value={filters.searchPrjTyp} onChange={handleFilterType} />
    </FilterToggleRow>
  );
};

export default ChanceStatusList;
